import React, { useContext, useState, useMemo } from "react";
import styled from "@emotion/styled";
import "./Calendario.css";
import { useAtom } from "jotai";
import { colaboradoresAtom, fechaSeleccionadaAtom, totalDiasAtom } from "../../CalendarioStore";
import { useEffect } from "react";
import moment from "moment";
import { JefeInmediatoService } from "services/VacacionesService";
import { Popover, Tooltip } from "antd";
import { SecurityContext } from "context/SecurityContextProvider";

const MAX_ITEMS_LEYENDA = 6;
const RUC_SDF = "20330791684";
const RUC_SDF_ENERGIA = "20512436090";

const Calendario = () => {
	const [fechaSeleccionada] = useAtom(fechaSeleccionadaAtom);
	const [colaboradores, setColaboradores] = useAtom(colaboradoresAtom);
	const { getUsuarioAutenticado } = useContext(SecurityContext);

	const ruc = getUsuarioAutenticado().empresaSeleccionada?.ruc;
	const mostrarLeyenda = ruc === RUC_SDF || ruc === RUC_SDF_ENERGIA;

	const cargarColaboradores = async () => {
		const response = await JefeInmediatoService.listarColaboradores({
			mes: fechaSeleccionada.month() + 1,
			anio: fechaSeleccionada.year(),
		});
		setColaboradores(response.colaboradores);
	};

	useEffect(() => {
		cargarColaboradores();
	}, [fechaSeleccionada]);

	return (
		// <Container>
		<div>
			{mostrarLeyenda && <Leyenda colaboradores={colaboradores} />}
			<div style={{ height: "calc(100vh - 270px)", overflow: "auto" }}>
				<Titulo />
				{colaboradores &&
					colaboradores.map((colaborador) => <Fila key={colaborador.id} colaborador={colaborador} />)}
			</div>
		</div>
		// </Container>
	);
};

const Leyenda = ({ colaboradores }) => {
	const items = useMemo(() => {
		const mapa = new Map();
		(colaboradores || []).forEach((colaborador) => {
			(colaborador.vacaciones || []).forEach((solicitud) => {
				const color = solicitud.color || "lightblue";
				if (!mapa.has(color)) {
					mapa.set(color, solicitud.nombre);
				}
			});
		});
		return Array.from(mapa, ([color, nombre]) => ({ color, nombre }));
	}, [colaboradores]);

	if (!items.length) {
		return null;
	}

	const visibles = items.slice(0, MAX_ITEMS_LEYENDA);
	const restantes = items.slice(MAX_ITEMS_LEYENDA);

	return (
		<div style={style.leyenda.container}>
			{visibles.map((item) => (
				<LeyendaItem key={item.color} item={item} />
			))}
			{restantes.length > 0 && (
				<Popover
					placement="bottomLeft"
					content={
						<div style={style.leyenda.popoverContent}>
							{restantes.map((item) => (
								<LeyendaItem key={item.color} item={item} />
							))}
						</div>
					}
				>
					<div style={style.leyenda.masItem}>+{restantes.length} más</div>
				</Popover>
			)}
		</div>
	);
};

const LeyendaItem = ({ item }) => (
	<div style={style.leyenda.item}>
		<span style={{ ...style.leyenda.muestra, backgroundColor: item.color }} />
		<span>{item.nombre}</span>
	</div>
);

const Titulo = () => {
	const [fechaSeleccionada] = useAtom(fechaSeleccionadaAtom);
	const [totalDays] = useAtom(totalDiasAtom);
	const [days, setDays] = useState(Array.from({ length: totalDays }, (_, index) => index + 1));

	const actualizarDias = () => {
		setDays(Array.from({ length: totalDays }, (_, index) => index + 1));
	};

	useEffect(() => {
		actualizarDias();
	}, [totalDays]);

	return (
		// <div style={{ height: "35px", display: "flex" }}>
		// 	<div style={{ width: "25%", border: "1px solid #ccc", borderRight: "0px", borderBottom: "0px" }}>
		// 		Nombres y Apellidos
		// 	</div>
		<div style={style.cabecera.container}>
            <div style={style.cabecera.celdaColaborador}>
                Nombres y Apellidos
            </div>
			<div style={{ width: "75%" }}>
				{/* <div className="fila" style={{ borderBottom: "0px" }}> */}
				<div style={style.cabecera.containerDias}>
					{days.map((day) => (
						<div key={day} className="day">
							<span>
								{moment({
									year: fechaSeleccionada.year(),
									month: fechaSeleccionada.month(),
									date: day,
								})
									.format("dd")
									.toUpperCase()}
							</span>
							<span>{day}</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

const Fila = ({ colaborador }) => {
	const [totalDays] = useAtom(totalDiasAtom);
	const [days, setDays] = useState(Array.from({ length: totalDays }, (_, index) => index + 1));

	const actualizarDias = () => {
		setDays(Array.from({ length: totalDays }, (_, index) => index + 1));
	};

	useEffect(() => {
		actualizarDias();
	}, [totalDays]);

	return (
		// <div style={{ height: "35px", display: "flex" }}>
		// 	<div style={{ width: "25%", border: "1px solid #ccc", borderRight: "0px" }}>
		// 		{colaborador.nombreCompleto}
		// 	</div>
		// 	<div style={{ width: "75%" }}>
		// 		<div className="fila">
		<div style={style.fila.container}>
            <div style={style.fila.celdaColaborador}>
                {colaborador.nombreCompleto}
            </div>
            <div style={{ width: "75%" }}>
                <div style={style.fila.containerDias}>
					{colaborador?.vacaciones &&
						colaborador.vacaciones?.map((solicitud) => (
							<Tooltip title={solicitud.nombre} placement="top">
								<div
									key={solicitud.id}
									className="highlight"
									style={{
										left: `calc( (${solicitud.diaInicio} - 1 )  * (100% / ${totalDays}))`,
										width: `calc(${solicitud.diasSolicitados} * (100% / ${totalDays}))`,
										backgroundColor: solicitud.color ? solicitud.color : "lightblue"
									}}
								>

								</div>
							</Tooltip>
						))}

					{days.map((day) => (
						<div key={day} className="day" />
					))}
				</div>
			</div>
		</div>
	);
};

const Container = styled.div`
	width: 100%;
`;

const ContainerDias = styled.div`
	width: 75%;
	// padding: 10px 10px;
`;

const ContainerColaboradores = styled.div`
	width: 25%;
	border: 1px solid #ccc;
`;

const style = {
    dias: {
        flex: "1",
        minWidth: "0",
        borderRight: "1px solid #ccc",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "10px",
    },
    cabecera: {
        container: {
            backgroundColor: "white",
            height: "35px",
            display: "flex",
            position: "sticky",
            top: 0,
            zIndex: 10
        },
        containerDias: {
            display: "flex",
            position: "relative",
            overflowX: "auto",
            border: "1px solid #ccc",
            borderRight: "0px",
            height: "100%",
        },
        celdaColaborador: {
            width: "25%",
            border: "1px solid #ccc",
            borderRight: "0px"
        }
    },
    fila: {
        container: {
            height: "35px",
            display: "flex"
        },
        containerDias: {
            display: "flex",
            position: "relative",
            overflowX: "auto",
            border: "1px solid #ccc",
            borderRight: "0px",
            height: "100%",
            borderTop: "0px"
        },
        celdaColaborador: {
            width: "25%",
            border: "1px solid #ccc",
            borderRight: "0px",
            borderTop: "0px"
        },
        celdaDias: {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            height: "50%",
            zIndex: "1",
            borderRadius: "15px",
        }
    },
    leyenda: {
        container: {
            display: "flex",
            flexWrap: "nowrap",
            alignItems: "center",
            gap: "16px",
            padding: "0 0 10px",
            overflow: "hidden",
        },
        item: {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "12px",
            whiteSpace: "nowrap",
        },
        muestra: {
            display: "inline-block",
            width: "12px",
            height: "12px",
            borderRadius: "3px",
            flexShrink: 0,
        },
        masItem: {
            fontSize: "12px",
            color: "#1890ff",
            cursor: "pointer",
            whiteSpace: "nowrap",
            flexShrink: 0,
        },
        popoverContent: {
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            maxHeight: "240px",
            overflowY: "auto",
            minWidth: "160px",
        }
    }
}

export default Calendario;
